import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"
import {Spinner} from "reactstrap"

class DashedLine extends Component {
  constructor(props) {
    super(props)

    this.state = {
      event:props.event,
      chargement:false,
      series: [
        {
          name: "T1",
          data: [34, 40, 28, 52, 42, 109, 100,200],
        },
        {
          name: "T3",
          data: [32, 60, 34, 46, 34, 52, 41,50],
        },
      ],
      options: {
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },

        colors: ["#556ee6", "#34c38f"],
        xaxis: {
          type: "datetime",
          
          categories: [
            "2017-01-19T00:00:00",
            "2018-02-19T01:30:00",
            "2018-03-19T02:30:00",
            "2018-07-19T03:30:00",
            "2018-08-19T04:30:00",
            "2018-09-19T05:30:00",
            "2018-10-19T06:30:00",
            "2018-10-19T07:30:00",
          ],
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      },
    }

    this.handleCountRessourceByMonth.bind(this)
  }

  handleCountRessourceByMonth=(data)=>{
    var ressource={}
    var resInit={}
    _.sortBy(data,"created_at").map((element,idx)=>{
      ressource[new Date(element.created_at).toDateString()]= ressource[new Date(element.created_at).toDateString()]?ressource[new Date(element.created_at).toDateString()]+1:1
      
      // try{
      //   ressource[new Date(element.created_at).toDateString()]= ressource[new Date(element.created_at).toDateString()]?ressource[new Date(element.created_at).toDateString()]+1:1
      //   console.log("==>111",resInit[new Date(element.created_at).toDateString()])
      // }catch(err){
      //   resInit[new Date(element.created_at).toDateString()]=1
      //   console.log("==>2222222",resInit[new Date(element.created_at).toDateString()])
      // }
     
      // ressource[element.created_at] = resInit[new Date(element.created_at).toDateString()]>1 ? resInit[new Date(element.created_at).toDateString()]+1 : 1;
   
      // console.log("==>",resInit[new Date(element.created_at).toDateString()])
    })
  
    return ressource;
  }

  componentDidMount() {
  
    var xx=[]
    var yy=[]
   
    var counter=this.handleCountRessourceByMonth(this.state.event)
    var key=Object.keys(counter)
    
    try{
      if(key.length){
       key.map((element,id)=>{
        
           xx.push(element)
           yy.push(counter[element])
           
          // console.log("xx-yy",xx,"yy",yy)
      
         if(id==Object.keys(counter).length-1){
           this.setState({
            chargement:true,


            series: [
              {
                name: "T1",
                data: yy,
              },
              
            ],
            options: {
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: "smooth",
                width: 3,
              },
      
              colors: ["#556ee6", "#34c38f"],
              xaxis: {
                type: "datetime",
                
                categories:xx,
              },
              grid: {
                borderColor: "#f1f1f1",
              },
              tooltip: {
                x: {
                  format: "dd/MM/yyyy",
                },
              },
            },




           })
         }
         
       })
      }
  
    }catch(error){

    }

  }
  render() {

    const series= [
      {
        name: "T1",
        data: this.state.valy  //[34, 40, 28, 52, 42, 109, 100,200],
      },
      // {
      //   name: "T3",
      //   data: [32, 60, 34, 46, 34, 52, 41,50],
      // },
    ]




   const options= {
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },

      colors: ["#556ee6", "#34c38f"],
      xaxis: {
        type: "datetime",
        categories:this.state.valx
        // categories: [
        //   "2017-01-19T00:00:00",
        //   "2018-02-19T01:30:00",
        //   "2018-03-19T02:30:00",
        //   "2018-07-19T03:30:00",
        //   "2018-08-19T04:30:00",
        //   "2018-09-19T05:30:00",
        //   "2018-10-19T06:30:00",
        //   "2018-10-19T07:30:00",
        // ],
      },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    
  }
    return (
      <React.Fragment>
        {
       (this.state.chargement)?
       (<>
        
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height="350"
          className="apex-charts"
        />
        </>):null
        
      }
      </React.Fragment>
    )
  }
}

export default DashedLine
